export enum LoadingKey {
  grid = 'grid',
  comment = 'comment',
  community = 'community',
  items = 'items',
  search = 'search'
}
